import React, { useEffect, useState } from "react";
import { Table, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../../store/store";
import {
  fetchEchsProcedure,
  fetchEnhancements,
  fetchProceduresForEnhancement,
  fetchSpecialitiesForEnhancement,
} from "../../../models/EnhancementSliceForCghs";
import EnhancementModal from "./NewEnhancementModalForCghs";
import { EnhancementTableRecord } from "../../../interfaces/IEnhancementForCghs";
import { ColumnsType } from "antd/es/table";
import { enhancementService } from "../../../apis/patientService";
import { getPortalData } from "../../../models/preAuthSlice";

interface EnhancementListProps {
  onfetchStepper: () => void; // Define prop type for the function
}
const EnhancementList: React.FC<EnhancementListProps> = ({
  onfetchStepper,
}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [portalMetaDataId, setPortalMetaDataId] = useState<number>(0);
  const getIds = useSelector((state: RootState) => state.patients);
  const { preAuth } = useSelector((state: RootState) => state);
  const [claimId, setClaimId] = useState("");
  const dispatch = useDispatch<AppDispatch>();
  const {
    data: enhancements,
    loading,
    error,
  } = useSelector((state: RootState) => state.enhancementCghs);
  const { patients, hospital } = useSelector((state: RootState) => state);

  useEffect(() => {
    if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
      // if (
      //   patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
      //   "ECHS" && patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId
      // ) {
      //   dispatch(
      //     fetchEchsProcedure({
      //       hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
      //       patientType:
      //         patients?.fetchBasicDetails?.visitInfoResponse?.visitType === "OP"
      //           ? "OP"
      //           : "IP",
      //       schemeId:
      //         patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
      //     })
      //   );
      // } else {
        dispatch(
          fetchProceduresForEnhancement({
            hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
            isCghs:
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
              "CGHS"
                ? true
                : false,
            procedureType:
              patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
              "OP"
                ? "OP"
                : "IP",
            schemeId:
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          })
        );
      // }
      dispatch(fetchSpecialitiesForEnhancement());
    }
  }, [dispatch, patients?.fetchBasicDetails?.casesResponse?.healthCareId]);

  const handleGetData = () => {
    const caseId = getIds?.fetchBasicDetails?.casesResponse?.id;
    const visitId = getIds?.fetchBasicDetails?.visitInfoResponse?.id;
    if (caseId && visitId) {
      dispatch(getPortalData({ caseId, visitId }));
    }
  };

  useEffect(() => {
    setClaimId(
      preAuth?.portalData?.casePreAuthCghs?.claimId ||
        preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsReferralResponse
          ?.claimId ||
        preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsEmergencyResponse
          ?.claimId ||
        preAuth?.portalData?.casePreAuthIhx?.claimId ||
        preAuth?.portalData?.casePreAuthStarhealth?.claimId
    );
  }, [preAuth?.portalData]);

  useEffect(() => {
    const caseId = getIds?.fetchBasicDetails?.casesResponse?.id;
    const visitId = getIds?.fetchBasicDetails?.visitInfoResponse?.id;
    if (caseId && visitId) {
      handleGetData();
    }
  }, [
    getIds?.fetchBasicDetails?.casesResponse?.id,
    getIds?.fetchBasicDetails?.visitInfoResponse?.id,
  ]);

  useEffect(() => {
    const fetchData = async () => {
      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;

      if (caseId && visitId) {
        dispatch(fetchEnhancements({ caseId, visitId }));
        if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
          const portalMetaData = await enhancementService.getPortalMetaData(
            patients.fetchBasicDetails.casesResponse.schemeMetaDataId
          );
          if (
            portalMetaData.portalMetaDataIdsList &&
            portalMetaData.portalMetaDataIdsList.length > 0
          ) {
            setPortalMetaDataId(portalMetaData.portalMetaDataIdsList[0]);
          }
        }
      }
    };

    fetchData();
  }, [
    dispatch,
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
  ]);

  const columns: ColumnsType<EnhancementTableRecord> = [
    {
      title: "Initiated Date",
      dataIndex: "initiatedDate",
      key: "initiatedDate",
    },
    {
      title: "Claim ID",
      dataIndex: "claimId",
      key: "claimId",
    },
    {
      title: "Enhance Type (Procedure)",
      dataIndex: "procedure",
      key: "procedure",
    },
    {
      title: "Enhance Type (Shift)",
      dataIndex: "shift",
      key: "shift",
    },
    {
      title: "Enhance Type (Days)",
      dataIndex: "days",
      key: "days",
    },
    {
      title: "Requested Amount",
      dataIndex: "requestedAmount",
      key: "requestedAmount",
    },
    {
      title: "Approved Amount",
      dataIndex: "approvedAmount",
      key: "approvedAmount",
    },
    {
      title: "Date Of Approval / Rejection",
      dataIndex: "dateOfApprovalRejection",
      key: "dateOfApprovalRejection",
    },
    // {
    //   title: "Documents",
    //   dataIndex: "noOfDays",
    //   key: "noOfDays",
    // },
    {
      title: "Status",
      dataIndex: "stageStateDto",
      key: "stageStateDto",
      //   render: (stageStateDto: any) => (

      //     <span
      //       style={{
      //         color: "#0C6EFF",
      //         backgroundColor:
      //           status === "Approved"
      //             ? "#0C6EFF33"
      //             : status === "Pending"
      //             ? "#D2691E33"
      //             : "#D51E1E33",
      //         padding: "0.25rem 1.1rem",
      //         borderRadius: "0.5rem",
      //         fontWeight:"600"
      //       }}
      //     >
      //       {status}
      //     </span>
      //   ),
      // },
      render: (stageStateDto: any) => {
        const status =
          stageStateDto?.stateName || stageStateDto?.stageName || "N/A"; // Fallback if both are null
        let color = "";
        let textColor = "";

        switch (status) {
          case "Completed":
            color = "#0C6EFF33";
            textColor = "#0C6EFF"; // Green
            break;
          case "Created":
            color = "#D2691E33"; // Orange
            textColor = "#D2691E";
            break;
          case "Rejected":
            color = "#D51E1E33";
            textColor = "#D51E1E";
            break;
          default:
            color = "#1890ff"; // Blue
        }

        return (
          <span
            style={{
              fontWeight: 500,
              fontSize: "14px",
              padding: "4px 16px",
              borderRadius: "9px",
              color: textColor,
              backgroundColor: color,
            }}
          >
            {status}
          </span>
        );
      },
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
    },
  ];

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div style={{ padding: "14px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <h2 style={{ fontSize: "25px", fontWeight: "700" }}>
          Enhancement List
        </h2>
        <Button icon={<PlusOutlined />} onClick={() => setIsModalOpen(true)}>
          ADD NEW ENHANCEMENT
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={enhancements}
        pagination={false}
        className="custom-table"
        onRow={(record, index: any) => ({
          style: {
            backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
          },
        })}
      />

      {isModalOpen && (
        <EnhancementModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          portalMetaDataId={portalMetaDataId}
          onfetchStepper={onfetchStepper}
          claimId={claimId}
        />
      )}
    </div>
  );
};

export default EnhancementList;
